import React from "react";
import image from "../../Assets/connectImg.png";
import "./Connectme.css";
import linkedin from "../../Assets/linkedinlogo.png";
import insta from "../../Assets/instalogo.png";
import github from "../../Assets/GitHub-logo.png";
import x from "../../Assets/xlogo.png";

const links = [
  {
    img: linkedin,
    link: "https://www.linkedin.com/in/sahil-rohera-202939214/",
    color: "#0274B3",
    name: "LinkedIn",
  },
  {
    img: insta,
    link: "https://www.instagram.com/sahilrohera10/",
    color: "#FE0084",
    name: "Instagram",
  },
  {
    img: github,
    link: "https://github.com/sahilrohera10",
    color: "#000000",
    name: "Github",
  },
  {
    img: x,
    link: "https://twitter.com/sahilrohera10",
    color: "#000000",
    name: "X",
  },
];

export default function Connectme() {
  return (
    <div className="connectme">
      <h1 className="connectHead">Get In Touch With Me</h1>
      <div className="flex">
        <div className="flexleft">
          <img className="leftImg" src={image} alt="" />
        </div>
        <div className="flexright">
          <div className="container">
            {links.map((d) => (
              <a style={{ textDecoration: "none" }} href={d.link}>
                <div className="item" style={{ background: d.color }}>
                  <img className="logoimg" src={d.img} alt="" />
                  <h2 className="itemtext"> {d.name} </h2>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
